<template>
  <div class="projects-container">
    <section>
      <!--工具条-->
      <el-col class="toolbar">
        <h2>
          <em></em>
          <span>{{$t("projectManage.title")}}</span>
        </h2>
        <div class="addNew">
          <div class="newBtn" @click="handleAdd">{{$t("projectManage.create")}}</div>
        </div>
      </el-col>

      <div class="project-container">
        <!--列表-->
        <el-table
          :data="projects"
          :empty-text="$t('common.noData')"
          highlight-current-row
          v-loading="listLoading"
          min-width="100%"
        >
          <el-table-column prop="name" :label="$t('projectManage.name')" min-width="10%"></el-table-column>
          <el-table-column prop="apikey" :label="$t('projectManage.apikey')" min-width="32%">
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content">{{scope.row.apikey}}</div>
              <p class="keyP">{{scope.row.apikey}}</p>
              </el-tooltip>
              <div @click="copy('apikey', scope.row)" class="tag"></div>
            </template>
          </el-table-column>
          <el-table-column prop="secret" :label="$t('projectManage.secret')" min-width="32%">
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content">{{scope.row.secret}}</div>
                <p class="keyP">{{scope.row.secret}}</p>
              </el-tooltip>
              <div @click="copy('secret', scope.row)" class="tag"></div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="status" :label="$t('projectManage.status')" min-width="11%"></el-table-column> -->
          <el-table-column :label="$t('projectManage.operation')" min-width="15%">
            <template scope="scope">
              <el-button
                size="small"
                @click="handleEdit(scope.$index, scope.row)"
              >{{$t("projectManage.edit")}}</el-button>
              <el-button
                type
                size="small"
                @click="handleDel(scope.$index, scope.row)"
              >{{$t("projectManage.delete")}}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog
          :title="$t('projectManage.editWndTitle')"
          v-model="editFormVisible"
          :close-on-click-modal="false"
        >
          <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
            <el-form-item :label="$t('projectManage.editWndName')" prop="name">
              <el-input v-model="editForm.name" auto-complete="off" @keyup.enter.native="editSubmit"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click.native="editFormVisible = false">{{$t("common.cancel")}}</el-button>
            <el-button
              type="primary"
              @click.native="editSubmit"
              :loading="editLoading"
            >{{$t("common.submit")}}</el-button>
          </div>
        </el-dialog>

        <!--新增界面-->
        <el-dialog
          :title="$t('projectManage.createWndTitle')"
          v-model="addFormVisible"
          :close-on-click-modal="false"
        >
          <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
            <el-form-item :label="$t('projectManage.createWndName')" prop="name">
              <el-input v-model="addForm.name" auto-complete="off" @keyup.enter.native="addSubmit"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click.native="addFormVisible = false">{{$t("common.cancel")}}</el-button>
            <el-button
              type="primary"
              @click.native="addSubmit"
              :loading="addLoading"
            >{{$t("common.submit")}}</el-button>
          </div>
        </el-dialog>
      </div>
      <div class="EndpointBox">
        <p>
          <span class="EndpointTit">{{$t("projectManage.endpoint")}}</span>
          <el-select v-model="network" @change="selectNetwork">
            <el-option
              v-for="item in networks"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <span class="EndpointCon">{{endpoint}}</span>
        </p>
        <!-- <pagination/> -->
      </div>
    </section>
  </div>
</template>

<script>
import api from "../../api/api";
import { resCode, pattern } from "../../../server/common/data";
// import pagination from "../../components/Pagination/Pagination";
import Clipboard from "clipboard";

export default {
  // components: {
  //   pagination
  // },
  data() {
    var validateName = (rule, value, cb) => {
      if (value === "") {
        cb(new Error(this.$t("projectManage.nameRequired")));
      } else if (!pattern.projectname.test(value)) {
        cb(new Error(this.$t("projectManage.nameFormat")));
      } else {
        api
          .checkProjectExist({ name: value })
          .then(res => {
            if (res.data.CODE !== resCode.PROJECT_NOT_FOUND) {
              cb(new Error(this.$t("projectManage.nameUsed")));
            } else {
              cb();
            }
          })
          .catch(() => {
            cb();
          });
      }
    };
    return {
      networks: [],
      network: "",
      endpoints: {},
      endpoint: "",
      projects: [],
      listLoading: false,
      // sels: [], //列表选中列

      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        name: [{ validator: validateName, trigger: "blur" }]
      },
      //编辑界面数据
      editForm: {
        name: "",
        apikey: "",
        secret: ""
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        name: [{ validator: validateName, trigger: "blur" }]
      },
      //新增界面数据
      addForm: {
        name: "",
        apikey: "",
        secret: ""
      }
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.page = val;
      this.getProjects();
    },
    getProjects() {
      this.listLoading = true;
      api
        .getProjects({})
        .then(res => {
          if (res.data.CODE === resCode.SUCCESS) {
            this.projects = res.data.DATA;
          } else {
            this.projects = [];
          }
          this.listLoading = false;
        })
        .catch(() => {});
    },
    //删除
    handleDel: function(index, row) {
      this.$confirm(
        this.$t("projectManage.deleteWndInfo"),
        this.$t("common.reminder"),
        {
          type: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t("common.submit"),
          cancelButtonText: this.$t("common.cancel")
        }
      )
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          api
            .deleteProject({ apikey: row.apikey })
            .then(res => {
              this.listLoading = false;
              //NProgress.done();
              this.$message({
                message: this.$t("projectManage.deleteSuccess"),
                type: "success"
              });
              this.getProjects();
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd: function() {
      this.addFormVisible = true;
      this.addForm = {
        name: "",
        apikey: "",
        secret: ""
      };
    },
    //编辑
    editSubmit: function() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.editLoading = true;
          let para = {
            apikey: this.editForm.apikey,
            name: this.editForm.name
          };
          api
            .modifyProject(para)
            .then(res => {
              this.editLoading = false;
              this.$message({
                message: this.$t("projectManage.editSuccess"),
                type: "success"
              });
              this.$refs["editForm"].resetFields();
              this.editFormVisible = false;
              this.getProjects();
            })
            .catch(() => {});
        }
      });
    },
    //新增
    addSubmit: function() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.addLoading = true;
          api
            .createProject({ name: this.addForm.name })
            .then(res => {
              this.addLoading = false;
              this.$message({
                message: this.$t("projectManage.createSuccess"),
                type: "success"
              });
              this.$refs["addForm"].resetFields();
              this.addFormVisible = false;
              this.getProjects();
            })
            .catch(() => {});
        }
      });
    },
    // copy
    copy(column, data) {
      let clipboard = new Clipboard(".tag", {
        text: function() {
          if (column === "apikey") {
            return data.apikey;
          } else {
            return data.secret;
          }
        }
      });
      clipboard.on("success", e => {
        this.$message({message: this.$t("common.copySuccess"), showClose: true,  type: "success"});
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        this.$message({message: this.$t("common.copyFailed"), showClose: true, type: "error"});
        clipboard.destroy();
      });
    },
    getEndpoints(apikey) {
        api
          .getEndpoints({apikey: apikey})
          .then(res => {
            if (res.data.CODE === resCode.SUCCESS) {
              this.endpoints = res.data.DATA;              
              for (let name in this.endpoints) {                
                this.networks.push({value: name, label: name});
              }
              // init list
              this.network = this.networks[0].value;
              this.selectNetwork(this.network);
            } else {
              this.endpoints = {};
              this.networks = [];
            }
          })
          .catch(() => {});
    },
    selectNetwork(select) {
      this.endpoint = this.endpoints[select] + "YOUR-API-KEY";
    }
  },
  mounted() {
    this.getProjects();
    this.getEndpoints("");
  }
};
</script>

<style lang="scss">
.el-table__body {
  width: 100% !important;
}
.projects-container {
  width: 100% !important;
  .addNew {
    float: right;
    cursor: pointer;
    .newBtn:hover {
      background-image: linear-gradient(90deg, #f1e0bc 0%, #e6c680 100%);
    }
    .newBtn {
      color: #fff;
      font-size: 16px;
      border: none;
      font-weight: normal;
      margin-top: 4px;
      padding: 6px 10px;
      margin-right: 15px;
      background-image: linear-gradient(90deg, #e6c680 0%, #f1e0bc 100%);
      border-radius: 6px;
    }
  }
  table {
    border: none !important;
    .el-button {
      border: none;
      color: #e7bd62;
      font-size: 14px;
      border-radius: 13px;
      background: #fff0;
    }
    .el-button:focus,
    .el-button:hover {
      color: #fff !important;
    }
  }
  .project-container {
    width: 99%;
    // height: 480px;
    margin: 80px 10px 0;
    border: none;
    border: 1px solid #e2e2e2;
    .el-table {
      border: none !important;
      .el-table th {
        background-color: #f4f7f9 !important;
      }
      tr:nth-child(even) {
        background-color: #f4f7f9 !important;
      }
      tr {
        border-radius: 8px;
        th {
          height: 46px;
          border: none;
          // background-color: #f4f7f9;
        }
        td {
          height: 46px;
          border: none;
        }
      }
      .el-table__column-resize-proxy {
        border: none;
      }
    }
  }
  .el-table::after,
  .el-table::before {
    background-color: #fff0;
  }
  .el-button--primary {
    background-color: #fff;
    border-color: #fff;
    background-image: linear-gradient(90deg, #e6c680 0%, #f1e0bc 100%);
  }
  .el-button--danger {
    background-image: linear-gradient(90deg, #e6c680 0%, #f1e0bc 100%);
    border: 1px solid #fff;
  }
  .el-button:focus,
  .el-button:hover {
    color: #fff !important;
  }
  .el-button--primary:focus,
  .el-button--primary:hover {
    border: 1px solid #fff0;
  }
}
.el-button--danger {
  background-image: linear-gradient(90deg, #e6c680 0%, #f1e0bc 100%);
  border: 1px solid #fff;
}
.el-button:focus,
.el-button:hover {
  color: #fff !important;
}
.el-button--primary {
  background-color: #fff;
  border-color: #fff;
  background-image: linear-gradient(90deg, #e6c680 0%, #f1e0bc 100%);
}
.el-table__body tr.current-row > td {
  background: #ffffff;
}
.EndpointBox {
  // width: 96%;
  display: inline-block;
  margin: 30px 2%;
  p {
    .EndpointTit {
      font-size: 16px;
      font-weight: bold;
      color: #666;
    }
    .el-input {
      width: 120px;
      margin: 0 12px;
    }
    .el-input__inner {
      height: 26px;
    }
    .EndpointCon {
      font-size: 14px;
      padding: 4px 5px;
      border: 1px solid #d1d1d1;
    }
  }

  .el-select-dropdown__list {
    list-style: none;
    padding: 0 !important;
    margin: 0;
    box-sizing: border-box;
  }

  .el-select-dropdown__item {
    font-size: 14px;
    padding: 2px 10px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #48576a;
    /* height: 36px; */
    line-height: 1.5;
    box-sizing: border-box;
    cursor: pointer;
  }
}
.keyP {
  float: left;
  width: 93%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tag {
  // float: left;
  width: 16px;
  height: 14px;
  display: inline-block;
  background: url("../../assets/copy.png") no-repeat center center;
  background-size: contain;
  vertical-align: middle;
}
.tag:hover {
  background: url("../../assets/copy1.png") no-repeat center center;
  background-size: contain;
  vertical-align: middle;
  cursor: pointer;
}
.el-table th {
  text-align: center !important;
}
.el-table td {
  text-align: center !important;
}
</style>


// WEBPACK FOOTER //
// ProjectManagement.vue?c72131ea